import { createSharedComposable } from '@vueuse/core'
import type { RouteLocationNormalized } from 'vue-router'
import {
  isTrackablePath,
  pushRecent,
  resolvePageLabel,
  type RecentPage,
} from '~/utils/nav/recents'

function _useRecentPages() {
  const { user } = useUserSession()
  // Per-user key so a shared workstation does not leak one user's page history to the next.
  const recents = useLocalStorage<RecentPage[]>(
    () => `admin:nav:recent-pages:${user.value?.sub ?? 'anon'}`,
    [],
  )

  const track = (to: RouteLocationNormalized) => {
    if (!isTrackablePath(to.path)) return
    recents.value = pushRecent(recents.value, {
      path: to.fullPath,
      label: resolvePageLabel(to.path, to.meta.title),
      visitedAt: new Date().toISOString(),
    })
  }

  const remove = (path: string) => {
    recents.value = recents.value.filter((recent) => recent.path !== path)
  }
  const clear = () => {
    recents.value = []
  }

  return { recents, track, remove, clear }
}

export const useRecentPages = createSharedComposable(_useRecentPages)
